import Constants from 'constants.js';
import Dispatcher from 'core/Dispatcher';
import { ExportToCsv } from 'export-to-csv';
// Service
import AccountService from 'services/AccountService';
// Locales
import translate from 'locales/i18n';
// Facade
import Facade from 'core/Facade';
// Action
import SiteAction from 'actions/SiteAction';
import AlertAction from './AlertAction';

class AccountAction {
    getAccounts(options) {
        Dispatcher.dispatch({
            actionType: Constants.ACCOUNTS_GET_START
        });

        AccountService.getAccounts(options).then(data => {
            Dispatcher.dispatch({
                actionType: Constants.ACCOUNTS_GET_END,
                value: Facade.keysToCamel(data)
            });

            SiteAction.getSites();
        }, err => {
            console.log(err);
        });
    }

    getAccount() {
        Dispatcher.dispatch({
            actionType: Constants.ACCOUNT_GET_START
        });

        AccountService.getAccounts().then(data => {
            Dispatcher.dispatch({
                actionType: Constants.ACCOUNT_GET_END,
                value: Facade.keysToCamel(data)
            });
        }, err => {
            console.log(err);
        });
    }

    addAccount(options) {
        AccountService.addAccount(options).then(data => {
            const newAccount = options;
            options.id = data.id;

            Dispatcher.dispatch({
                actionType: Constants.ACCOUNT_ADDED,
                value: newAccount
            });

            AlertAction.open('success', translate.i18n('SUCCESS_ADD_ACCOUNT'), 'top-right');
        }, err => {
            console.log(err);
            AlertAction.open('error', translate.i18n('ERROR_ADD_ACCOUNT'), 'top-right');
        });
    }

    duplicateAccount(account) {
        AccountService.duplicateAccount(account.id, account.name).then(data => {
            const newAccount = account;
            newAccount.id = data.id;

            Dispatcher.dispatch({
                actionType: Constants.ACCOUNT_ADDED,
                value: newAccount
            });

            AlertAction.open('success', translate.i18n('SUCCESS_DUPLICATE_ACCOUNT'), 'top-right');
        }, err => {
            console.log(err);
            AlertAction.open('error', translate.i18n('ERROR_DUPLICATE_ACCOUNT'), 'top-right');
        });
    }

    updateAccount(options, id) {
        AccountService.updateAccount(options, id).then((response) => {
            Dispatcher.dispatch({
                actionType: Constants.ACCOUNT_UPDATED,
                value: Facade.keysToCamel(response)
            });

            AlertAction.open('success', translate.i18n('SUCCESS_UPDATE_ACCOUNT'), 'top-right');
        }, err => {
            console.log(err);
            AlertAction.open('error', translate.i18n('ERROR_UPDATE_ACCOUNT'), 'top-right');
        });
    }

    deleteAccount(id) {
        AccountService.deleteAccount(id).then(() => {
            Dispatcher.dispatch({
                actionType: Constants.ACCOUNT_DELETED,
                value: {
                    id
                }
            });
        }, err => {
            console.log(err);
        });
    }

    getAccountUsers(id) {
        return AccountService.getAccountUsers(id).then(users => users, err => console.log(err));
    }

    getModule(id, module) {
        return AccountService.getModule(id, module).then(data => data, err => console.log(err));
    }

    exportData(exportOptions, accountId) {
        const dataExported = [];

        Dispatcher.dispatch({
            actionType: Constants.ITEM_EXPORT_START
        });

        AccountService.getExportData(accountId).then(data => {
            data.data.forEach((item) => {
                const newData = {};
                data.header.forEach(h => newData[h] = item[h]);
                dataExported.push(newData);
                return true;
            });
            if (dataExported.length > 0) {
                const csvExporter = new ExportToCsv(exportOptions);
                csvExporter.generateCsv(dataExported);
            } else {
                AlertAction.open('error', translate.i18n('ERROR_DATA_EXPORT'), 'top-right');
            }
        });
    }

    exportMissingAdditionalData(exportOptions, accountId) {

        const dataExported = [];

        AccountService.getExportMissingAdditionalData(accountId, exportOptions).then(data => {

            let isGoodSeparator = true;

            data.content.forEach((item) => {
                const newData = {};
                console.log(item);
                if (item[1].includes(exportOptions.fieldSeparator) ||
                    item[2].includes(exportOptions.fieldSeparator) ||
                    item[3].includes(exportOptions.fieldSeparator) ||
                    item[4].includes(exportOptions.fieldSeparator) ||
                    item[5].includes(exportOptions.fieldSeparator) ||
                    item[6].includes(exportOptions.fieldSeparator)) isGoodSeparator = false;
                data.headers.forEach((h,index) => newData[h] = item[index]);
                dataExported.push(newData);
                return true;
            });
            if (isGoodSeparator) {
                if (dataExported.length > 0) {
                    const csvExporter = new ExportToCsv(exportOptions);
                    csvExporter.generateCsv(dataExported);
                } else {
                    AlertAction.open('error', translate.i18n('ERROR_DATA_EXPORT'), 'top-right');
                }
            } else {
                AlertAction.open('error', 'Choisissez un autre séparateur', 'top-right');
            }
        });
    }
}

export default new AccountAction();
